import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import CancelIcon from '@material-ui/icons/Cancel';
import { BookUploadContext } from "./context";
import InputChapter from "./InputChapter";
import InputTopic from "./InputTopic";
import InputSelecCheckBox from "./inputCheckbox.js";

const ChapterTopicMain = styled.div`
	display: flex;
	width: 671px;
	padding: 24px 16px;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	gap: 20px;
	border-radius: 12px;
	border: 2px solid #E5E7EB;
`

const ChapterTopicHeader = styled.span`
	display: flex;
	flex-direction: row;
	gap: 10px;
	align-items: center;
	margin-right: 500px;
`

const AddBtn = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 631px;
	height: 32px;
	padding: 8px 0px;
	align-items: center;
	border-radius: 24px;
	background: #DFE8FB;
	border: none;
	span{
		color: #0047B6;
		text-align: center;
		font-family: Public Sans;
		font-size: 14px;
		font-style: normal;
		font-weight: 700;
		line-height: 24px;
	}
`

const NewTopic = (chapterId, topicId) => {
	return (
		<div>
			<InputTopic
				placeholder="Título do tópico"
				width="630px"
				spanText="Digite o título do tópico "
				chapterId={`${chapterId}`}
				topicId={topicId}
				field={"topic"}
			/>
			<div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
				<InputTopic
					placeholder="Página inicial"
					width="300px"
					spanText="Página inicial do capítulo "
					chapterId={`${chapterId}`}
					topicId={topicId}
					field={"first_page"}
				/>
				<InputTopic
					placeholder="Página final"
					width="300px"
					spanText="Página final do capítulo "
					chapterId={`${chapterId}`}
					topicId={topicId}
					field={"last_page"}
				/>
			</div>
		</div >
	)
}

const ChapterTopic = ({ setTopicInfo, topicInfo, chapterId, chapterInfo }) => {
	const [handler, setHandler] = useState(0);
	const { data, setData } = useContext(BookUploadContext);

	const handleDeleteChapter = () => {
		setData(data.filter((currentData) => currentData.capitulo !== chapterId + 1))
	}

	const handleNewTopic = () => {
		data.map((obj) => {
			if (obj.id === chapterId) {
				const newTopic = {
					id: (obj["topic"] ? obj["topic"].length : 0),
					topic: "",
					first_page: 0,
					last_page: 0,
				}
				if (obj["topic"]) {
					obj["topic"] = [...obj["topic"], newTopic]
				} else {
					obj["topic"] = [newTopic]
				}
			}
		})

		setData(data);
		setHandler(handler + 1);
	}
	return (
		<ChapterTopicMain>
			<ChapterTopicHeader>
				<CancelIcon
					style={{ cursor: 'pointer' }}
					onClick={handleDeleteChapter}
				/>
				Excluir capítulo
			</ChapterTopicHeader>
			<div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
				<InputChapter
					placeholder="Digite o título do capítulo"
					width="407px"
					spanText="Título do capítulo"
					chapterId={chapterId}
					field={"nome"}
				/>
				<InputChapter
					placeholder="Número do capítulo"
					width="203px"
					spanText="Número do capítulo"
					chapterId={chapterId}
					field={"capitulo"}
				/>
			</div>
			<div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
				<InputChapter
					placeholder="Página inicial"
					width="305px"
					spanText="Página inicial do capítulo"
					chapterId={chapterId}
					field={"first_page"}
				/>
				<InputChapter
					placeholder="Página final"
					width="305px"
					spanText="Página final do capítulo"
					chapterId={chapterId}
					field={"last_page"}
				/>
			</div>
			<div style={{ display: "flex", flexDirection: "row" }}>
				<InputSelecCheckBox
					placeholder={"Selecione habilidades"}
					chapterId={chapterId}
				/>
			</div>
			{data.map((obj) => {
				if (obj.id === chapterId && obj["topic"]) {
					return (obj["topic"].map((tipo, index) => {
						return NewTopic(chapterId, index);
					}
					))
				}
			})}
			<AddBtn onClick={handleNewTopic}>
				<span>Adicionar novo tópico</span>
			</AddBtn>
		</ChapterTopicMain>
	)
}

export default ChapterTopic;
